var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.currentStep && _vm.currentStep.includeInCount)?_c('div',{staticClass:"quote-progress",class:{ full: _vm.full }},[_c('div',{staticClass:"progress-bar",style:(_vm.progressBarWidth)},[_c('img',{style:(_vm.cssVaribles),attrs:{"src":_vm.icons[_vm.type],"alt":"progress-icon"}})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }